// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"493e5017","629":"0b494a7c","983":"4f02e24b"}[chunkId] + ".chunk.js";
};